import 'twin.macro';
import React from 'react';
import { CJEvent } from '@teetsh/app/src/types/event';
import { OneCard } from 'containers/CahierJournal/DayColumn/Seance/OneCard';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';

interface Props {
  event: CJEvent;
  className?: string;
  onReorder: (direction: -1 | 1) => void;
  isFirstEventInRow: boolean;
  isLastEventInRow: boolean;
  isHighlighted: boolean;
  classrooms: Classroom[];
  classroomsOrg: ClassroomsOrg;
  collapsed: boolean;
  onChange: (v: CJEvent) => void;
  onRotateGroups?: () => void;
  rowIndex: number;
}

export function Seance({
  event,
  className,
  onReorder,
  isFirstEventInRow,
  isLastEventInRow,
  isHighlighted,
  classrooms,
  classroomsOrg,
  collapsed,
  onChange,
  onRotateGroups,
  rowIndex,
}: Props) {
  const user = useUser();

  return (
    <div
      data-testid={event.type !== 'add-event' ? 'seance' : ''}
      tw="flex flex-1 text-sm min-w-0"
      className={className}
    >
      <OneCard
        rowIndex={rowIndex}
        onChange={onChange}
        collapsed={collapsed}
        classroomsOrg={classroomsOrg}
        classrooms={classrooms}
        boLabels={user.boLabels}
        condensed={user?.fonts?.cj?.condensed || false}
        onReorder={onReorder}
        onRotateGroups={onRotateGroups}
        event={event}
        isFirstEventInRow={isFirstEventInRow}
        isLastEventInRow={isLastEventInRow}
        isHighlighted={isHighlighted}
      />
    </div>
  );
}
